import { 
  InfoOutlined as InfoIcon,
  WarningAmberOutlined as WarningIcon,
  ReportOutlined as ReportIcon,
  AssignmentLateOutlined as AssignmentLateIcon
} from '@mui/icons-material';

interface Props {
  title: string;
  description: string;
  color?: string;
  icon?: 'info' | 'warning' | 'report' | 'late';
  iconColor?: string;
}

export const ReturnsIntakeDescription = ({ 
  title, 
  description, 
  color = '#3b82f6',
  icon = 'info',
  iconColor
}: Props) => {
  const IconComponent = 
    icon === 'warning' ? WarningIcon : 
    icon === 'report' ? ReportIcon : 
    icon === 'late' ? AssignmentLateIcon :
    InfoIcon;

  const finalIconColor = iconColor || color;

  return (
    <div 
      className='w-full flex items-center gap-4 p-5 bg-white rounded-sm shadow-md border-l-4'
      style={{ borderLeftColor: color }}
    >
      <div 
        className='flex items-center justify-center w-12 h-12 rounded-full'
        style={{ backgroundColor: `${finalIconColor}1A`, color: finalIconColor }}
      >
        <IconComponent sx={{ fontSize: '1.8rem' }} />
      </div>
      <div className='flex flex-col gap-1'>
        <h5 className='text-base font-black text-gray-800 uppercase tracking-tight'>
          {title}
        </h5>
        <p className='text-base text-gray-600 font-medium'>
          {description}
        </p>
      </div>
    </div>
  );
};
